<template>
  <layout>
    <div id="center">
      <div class="range">
        <div class="tabs">
          <TabCard />
        </div>
        <div class="content" v-loading="$store.state.loading">
          <transition name="el-fade-in-linear" mode="out-in">
            <router-view></router-view>
          </transition>
        </div>
        <div class="right">
          <PersonInfo />
          <RecommenD />
          <Feedback />
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import TabCard from "@/components/Base/TabCard.vue";
import RecommenD from "@/components/Base/RecommenD.vue";
import PersonInfo from "@/components/Base/PersonInfo.vue";
import Feedback from "@/components/Base/Feedback/index.vue";
import Layout from "@/components/Layout";

export default {
  components: {
    TabCard,
    RecommenD,
    PersonInfo,
    Feedback,
    Layout
  },
};
</script>

